<template>
  <div class="NewYearDialog" v-if="isShow">

    <CgModalMiddle
      :is-show-close="false"
    >
      <div slot="modal_content" class="modal_content">
        <i class="iconfont2 icon-qy-error-circle-fill" @click="close"/>
        <div class="coupon-list">
          <div class="coupon-item">
            <div class="layout-left">
              <div class="price-box">
                <span class="icon_dollar">¥</span>
                <span class="price">5</span>
              </div>
              <span class="act-txt">活动专享</span>
            </div>

            <div class="layout-right">
              <div class="coupon-name">全站通用</div>
              <div class="txt-use-time">当天有效</div>
            </div>
            <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" target="_blank" @click="close" class="btn-use">去使用</a>
          </div>
          <div class="coupon-item">
            <div class="layout-left">
              <div class="price-box">
                <span class="icon_dollar">¥</span>
                <span class="price">10</span>
              </div>
              <span class="act-txt">活动专享</span>
            </div>

            <div class="layout-right">
              <div class="coupon-name">全站满100可用</div>
              <div class="txt-use-time">当天有效</div>
            </div>
            <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" target="_blank" @click="close" class="btn-use">去使用</a>
          </div>
          <div class="coupon-item">
            <div class="layout-left">
              <div class="price-box">
                <span class="icon_dollar">¥</span>
                <span class="price">20</span>
              </div>
              <span class="act-txt">活动专享</span>
            </div>

            <div class="layout-right">
              <div class="coupon-name">企业VIP可用</div>
              <div class="txt-use-time">当天有效</div>
            </div>
            <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY" target="_blank" @click="close" class="btn-use">去使用</a>
          </div>
        </div>
      </div>
    </CgModalMiddle>
  </div>
</template>

<script>
import { PAGE_PATH } from "@/constant/PAGE_PATH"
import {getNewYearCoupon} from "@/api/act/newYear";
import {mapState} from "vuex";
import {fnLocalStorage, fnLogin} from "@/fn";
import {MODEL_NEW_YEAR_ACT} from "@/constant/MODELS";
export default {
  name: "NewYearDialog",
  data(){
    return{
      PAGE_PATH,
      isShow: false
    }
  },
  mounted() {

  },
  computed: {
    ...mapState('user',
      ['isLogin']
    ),
  },
  methods:{
    close(){
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.NewYearDialog {

  .modal_content {
    width: 200px;
    height: 200px;
    @include BgImage(491px, 532px, 'act/new-year/new-year%40dialog.png');

    .icon-qy-error-circle-fill{
      font-size: 38px;
      color: rgba(255, 255, 255, 0.8);
      cursor: pointer;
      position: absolute;
      bottom: -45px;
      left: 50%;
      transform: translateX(-50%);
      transition: transform 0.5s ease-out;

      &:hover{
        color: rgba(255, 255, 255, 0.9);
        transform: translateX(-50%) rotateZ(180deg);
      }
    }

    .coupon-list {
      width: 383px;
      position: absolute;
      top: 221px;
      left: 51px;

      .coupon-item {
        width: 100%;
        height: 83px;
        margin-bottom: 12px;
        display: flex;
        position: relative;

        .layout-left {
          width: 107px;
          margin-right: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .price-box {
            font-size: 0;
            color: #2D2B33;


            .icon_dollar {
              font-size: 18px;
              font-weight: bold;
              color: #FD2839;
              line-height: 13px;
              margin-right: 6px;
            }

            .price {
              line-height: 28px;
              font-size: 40px;
              font-weight: bold;
              color: #FD2839;
            }

            .time {
              font-size: 14px;
              font-weight: bold;
              line-height: 19px;
            }
          }

          .act-txt {
            font-size: 14px;
            font-weight: 400;
            color: #BB0F0C;
            margin-top: 9px;
          }
        }

        .layout-right {
          .coupon-name {
            line-height: 18px;
            font-size: 18px;
            font-weight: bold;
            color: #47141E;
            padding-top: 22px;
          }

          .txt-use-time {
            line-height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(71, 20, 30, 0.8);
            margin-top: 14px;
          }
        }

        .btn-use {
          display: inline-block;
          width: 76px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: linear-gradient(90deg, #FF5A00 0%, #FF1F4F 100%);
          border-radius: 15px;
          color: #FFFFFF;
          cursor: pointer;
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);

          &:hover {
            background: linear-gradient(90deg, #FF1F4F 0%, #FF5A00 100%);
          }

        }


        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
